module.exports = __webpack_public_path__ + "img/epr-price.cbce0ab9.jpg";